<div id="delete-confirm-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{'SHAREDMAILBOX-MANAGEMENT.DELETESHAREDMAILBOX.TITLE' | translate}}
        </span>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="dialog-container">
      <div class="dialog-content-wrapper">
        <div>
          <div>
            {{'SHAREDMAILBOX-MANAGEMENT.DELETESHAREDMAILBOX.CONFIRMPART1' |
            translate}}
          </div>
          <div class="sharemailboxName">{{sharemailboxName}}</div>
          <div class="sharemailboxName">
            {{'SHAREDMAILBOX-MANAGEMENT.DELETESHAREDMAILBOX.NORESTORATION' |
            translate}}
          </div>
        </div>
        @if (isBusyDeleteSharemailbox) {
        <div
          class="info-container"
          fxLayout="column"
          fxLayoutAlign="center center">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
          <br />
          <div fxFlex="100">
            {{'SHAREDMAILBOX-MANAGEMENT.DELETESHAREDMAILBOX.LOADINGDELETE' |
            translate}}
          </div>
        </div>
        }
        <div mat-dialog-actions class="btn-container">
          <button
            mat-raised-button
            class="mat-warn button-confirm"
            (click)="deleteSharemailbox()"
            [disabled]="isBusyDeleteSharemailbox || isSuccess">
            {{'GENERAL.CONFIRM' | translate}}
          </button>
          <button
            mat-button
            (click)="matDialogRef.close(false)"
            [disabled]="isBusyDeleteSharemailbox">
            {{'GENERAL.CANCEL' | translate}}
          </button>
        </div>
        @if (isError) {
        <div class="info-container" fxLayout="row" fxFill="100">
          <div class="message-box error user-created">
            <app-error-message [error]="error.error" />
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
